// extracted by mini-css-extract-plugin
export default {"wordbox":"TagsEdit_wordbox__xB9CT","feeling":"TagsEdit_feeling__ffWwI","alignBoxes":"TagsEdit_alignBoxes__gcyR5","includes":"TagsEdit_includes__SduBO"};